import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "klaviyo-notifier",
  class KlaviyoNotifier extends WYATTElement {
    constructor() {
      super();

      this.button = this.querySelector("button");

      if (!this.button) return;

      this.init();
    }

    init() {
      if (this.button) {
        this.button.addEventListener(
          "click",
          this.handleButtonClick.bind(this)
        );
      }
    }

    handleButtonClick = (event) => {
      event.preventDefault();

      // Get the form ID at click time to ensure it's available
      const productForm = this.button.closest("product-form");
      const klaviyoFormId = productForm?.getAttribute("data-klaviyo-form-id");

      if (!klaviyoFormId) {
        console.error("Klaviyo form ID not found");
        return;
      }

      // Set up Klaviyo tracking data
      if (window._learnq) {
        window._learnq.push([
          "track",
          "Back in Stock Request",
          {
            productId: this.config.productId,
            productTitle: this.config.productTitle,
            productHandle: this.config.productHandle,
            variantId: this.config.variantId,
            variantTitle: this.config.variantTitle,
            price: this.config.price,
            comparePrice: this.config.comparePrice,
          },
        ]);
      }

      // Open Klaviyo form
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", klaviyoFormId]);

      // Close any parent dialog
      this.closest("dialog")?.close();
    };

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      if (this.button) {
        this.button.removeEventListener("click", this.handleButtonClick);
      }
    }
  }
);
